// extracted by mini-css-extract-plugin
module.exports = {"id":"ProviderListTable_id__kUM-o"};